// import React, { useEffect, useState } from 'react';
// import {
//   Box, Typography, Button, Dialog, DialogActions,
//   DialogContent, DialogTitle, TextField, IconButton,
// } from '@mui/material';
// import { Delete, Edit } from '@mui/icons-material';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { API_BASE_URL } from '../../config';
// import { LoadingSpinner } from '../../Components/spinner/spinner';
// import api from '../../api/axiosInterceptor';
// import axios from 'axios';

// export const AdminAuctionComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const [openFormDialog, setOpenFormDialog] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [selectedAuction, setSelectedAuction] = useState(null);

//   const [formData, setFormData] = useState({
//     subject: '',
//     date_of_issue: '',
//     language: '',
//   });

//   const [selectedFile, setSelectedFile] = useState(null);

//   const [formErrors, setFormErrors] = useState({});

//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [deleteAuction, setDeleteAuction] = useState(null);

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
//     { id: 'subject', field: 'subject', headerName: 'Subject', width: 250 },
//     { id: 'dateOfIssue', field: 'dateOfIssue', headerName: 'Date Of Issue', width: 150 },
//     { id: 'language', field: 'language', headerName: 'Language', width: 150 },
//     {
//       id: 'links',
//       field: 'links',
//       headerName: 'Links',
//       width: 120,
//       renderCell: (params) =>
//         params.value ? (
//           <a href={params.value} target="_blank" rel="noopener noreferrer">
//             Download
//           </a>
//         ) : (
//           'No File'
//         ),
//     },
//     {
//       id: 'actions',
//       field: 'actions',
//       headerName: 'Actions',
//       width: 150,
//       renderCell: (params) => (
//         <>
//           <IconButton color="primary" onClick={() => handleEdit(params.row)}>
//             <Edit />
//           </IconButton>
//           <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)}>
//             <Delete />
//           </IconButton>
//         </>
//       ),
//     },
//   ];

//   useEffect(() => {
//     fetchAuctions();
//   }, []);

//   const fetchAuctions = () => {
//     setLoading(true);
//     axios
//       .get(`${API_BASE_URL}/home-notification/auction/`)
//       .then((response) => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id || index,
//           slNo: index + 1,
//           subject: item.subject,
//           dateOfIssue: item.date_of_issue,
//           language: item.language,
//           links: item.link || '',
//         }));
//         setRows(apiData);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error('Failed to fetch auction data:', error);
//         setSnackbarMessage('Failed to load auction data.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   };

//   const handleSnackbarClose = () => setSnackbarOpen(false);

//   const handleAddAuction = () => {
//     setIsEditMode(false);
//     setFormData({ subject: '', date_of_issue: '', language: '' });
//     setSelectedFile(null);
//     setFormErrors({});
//     setOpenFormDialog(true);
//   };

//   const handleEdit = (auction) => {
//     setIsEditMode(true);
//     setSelectedAuction(auction);
//     setFormData({
//       subject: auction.subject,
//       date_of_issue: auction.dateOfIssue,
//       language: auction.language,
//     });
//     setSelectedFile(null);
//     setFormErrors({});
//     setOpenFormDialog(true);
//   };

//   const handleDeleteConfirmation = (auction) => {
//     setDeleteAuction(auction);
//     setDeleteDialogOpen(true);
//   };

//   const handleDelete = () => {
//     api.delete(`${API_BASE_URL}/home-notification/auction/${deleteAuction.id}/`)
//       .then(() => {
//         setSnackbarMessage('Auction deleted successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         fetchAuctions();
//       })
//       .catch((error) => {
//         console.error('Delete failed:', error);
//         setSnackbarMessage('Failed to delete auction.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//       })
//       .finally(() => {
//         setDeleteDialogOpen(false);
//         setDeleteAuction(null);
//       });
//   };

//   const validateForm = () => {
//     const errors = {};
//     if (!formData.subject?.trim()) errors.subject = 'Subject is required';
//     if (!formData.date_of_issue) errors.date_of_issue = 'Date is required';
//     if (!formData.language?.trim()) errors.language = 'Language is required';
//     if (!selectedFile && !isEditMode) errors.file = 'File is required';
//     if (selectedFile && selectedFile.size > 2 * 1024 * 1024) errors.file = 'File size must be less than 2MB';
//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file && file.size > 2 * 1024 * 1024) {
//       setFormErrors((prev) => ({ ...prev, file: 'File size must be less than 2MB' }));
//       setSelectedFile(null);
//     } else {
//       setFormErrors((prev) => ({ ...prev, file: null }));
//       setSelectedFile(file);
//     }
//   };

//   const handleFormSubmit = () => {
//     if (!validateForm()) return;

//     const form = new FormData();
//     form.append('subject', formData.subject);
//     form.append('date_of_issue', formData.date_of_issue);
//     form.append('language', formData.language);
//     if (selectedFile) {
//       form.append('link', selectedFile); // backend expects 'link' for the uploaded file
//     }

//     if (isEditMode) {
//       api.patch(
//         `${API_BASE_URL}/home-notification/auction/${selectedAuction.id}/`,
//         form,
//         { headers: { 'Content-Type': 'multipart/form-data' } }
//       )
//         .then(() => {
//           setSnackbarMessage('Auction updated successfully.');
//           setSnackbarSeverity('success');
//           setSnackbarOpen(true);
//           fetchAuctions();
//         })
//         .catch((error) => {
//           console.error('Update failed:', error);
//           setSnackbarMessage('Failed to update auction.');
//           setSnackbarSeverity('error');
//           setSnackbarOpen(true);
//         })
//         .finally(() => setOpenFormDialog(false));
//     } else {
//       api.post(
//         `${API_BASE_URL}/home-notification/auction/`,
//         form,
//         { headers: { 'Content-Type': 'multipart/form-data' } }
//       )
//         .then(() => {
//           setSnackbarMessage('Auction added successfully.');
//           setSnackbarSeverity('success');
//           setSnackbarOpen(true);
//           fetchAuctions();
//         })
//         .catch((error) => {
//           console.error('Add failed:', error);
//           setSnackbarMessage('Failed to add auction.');
//           setSnackbarSeverity('error');
//           setSnackbarOpen(true);
//         })
//         .finally(() => setOpenFormDialog(false));
//     }
//   };

//   if (loading) {
//     return <LoadingSpinner size={30} />;
//   }

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         mt: 8,
//         mb: 1,
//         borderRadius: 2,
//         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//         backgroundColor: '#fff',
//       }}
//     >
//       <Box display="flex" justifyContent="space-between" alignItems="center" backgroundColor="rgba(195, 234, 203, 0.1)" p={2}>
//         <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
//           Admin Auction
//         </Typography>
//         <Button variant="contained" color="primary" onClick={handleAddAuction}>
//           Add Auction
//         </Button>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus
//         enableSort={true}
//         sx={{
//           '& .MuiDataGrid-columnHeaders': {
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             fontWeight: 'bold',
//           },
//         }}
//       />

//       <Dialog open={openFormDialog} onClose={() => setOpenFormDialog(false)}>
//         <DialogTitle>{isEditMode ? 'Edit Auction' : 'Add Auction'}</DialogTitle>
//         <DialogContent>
//           <TextField
//             margin="dense"
//             label="Subject"
//             fullWidth
//             value={formData.subject}
//             error={!!formErrors.subject}
//             helperText={formErrors.subject}
//             onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
//           />
//           <TextField
//             margin="dense"
//             label="Date of Issue"
//             type="date"
//             fullWidth
//             value={formData.date_of_issue}
//             error={!!formErrors.date_of_issue}
//             helperText={formErrors.date_of_issue}
//             onChange={(e) => setFormData({ ...formData, date_of_issue: e.target.value })}
//             InputLabelProps={{ shrink: true }}
//           />
//           <TextField
//             margin="dense"
//             label="Language"
//             fullWidth
//             value={formData.language}
//             error={!!formErrors.language}
//             helperText={formErrors.language}
//             onChange={(e) => setFormData({ ...formData, language: e.target.value })}
//           />
//           {/* File Upload Input */}
//           <Box mt={2}>
//             <input
//               accept="*"
//               style={{ display: 'block', marginTop: '8px' }}
//               id="file-upload"
//               type="file"
//               onChange={handleFileChange}
//             />
//             {formErrors.file && (
//               <Typography variant="body2" color="error">
//                 {formErrors.file}
//               </Typography>
//             )}
//             {/* Show existing file download link if in edit mode and no new file chosen */}
//             {isEditMode && !selectedFile && selectedAuction?.links && (
//               <Typography variant="body2" sx={{ mt: 1 }}>
//                 Current File:{' '}
//                 <a href={`${API_BASE_URL}${selectedAuction.links}`} target="_blank" rel="noopener noreferrer">
//                   Download
//                 </a>
//               </Typography>
//             )}
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenFormDialog(false)}>Cancel</Button>
//           <Button onClick={handleFormSubmit} variant="contained" color="primary">
//             {isEditMode ? 'Update' : 'Add'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>Are you sure you want to delete this auction?</DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
//           <Button onClick={handleDelete} variant="contained" color="error">
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
//     </Box>
//   );
// };



import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, TextField, IconButton,
} from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { API_BASE_URL } from '../../config';
import { LoadingSpinner } from '../../Components/spinner/spinner';
import api from '../../api/axiosInterceptor';
import axios from 'axios';

export const AdminAuctionComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedAuction, setSelectedAuction] = useState(null);

  const [formData, setFormData] = useState({
    subject: '',
    date_of_issue: '',
    language: '',
  });

  const [selectedFile, setSelectedFile] = useState(null);

  const [formErrors, setFormErrors] = useState({});

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteAuction, setDeleteAuction] = useState(null);

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
    { id: 'subject', field: 'subject', headerName: 'Subject', width: 250 },
    { id: 'dateOfIssue', field: 'dateOfIssue', headerName: 'Date Of Issue', width: 150 },
    { id: 'language', field: 'language', headerName: 'Language', width: 150 },
    {
      id: 'links',
      field: 'links',
      headerName: 'Links',
      width: 120,
      renderCell: (params) =>
        params.value ? (
          <a href={params.value} target="_blank" rel="noopener noreferrer">
            Download
          </a>
        ) : (
          'No File'
        ),
    },
    {
      id: 'actions',
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleEdit(params.row)}>
            <Edit />
          </IconButton>
          <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)}>
            <Delete />
          </IconButton>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchAuctions();
  }, []);

  const fetchAuctions = () => {
    setLoading(true);
    axios
      .get(`${API_BASE_URL}/home-notification/auction/`)
      .then((response) => {
        const apiData = response.data.map((item, index) => ({
          id: item.id || index,
          slNo: index + 1,
          subject: item.subject,
          dateOfIssue: item.date_of_issue,
          language: item.language,
          links: item.link || '',
        }));
        setRows(apiData);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Failed to fetch auction data:', error);
        setSnackbarMessage('Failed to load auction data.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleAddAuction = () => {
    setIsEditMode(false);
    setFormData({ subject: '', date_of_issue: '', language: '' });
    setSelectedFile(null);
    setFormErrors({});
    setOpenFormDialog(true);
  };

  const handleEdit = (auction) => {
    setIsEditMode(true);
    setSelectedAuction(auction);
    setFormData({
      subject: auction.subject,
      date_of_issue: auction.dateOfIssue,
      language: auction.language,
    });
    setSelectedFile(null);
    setFormErrors({});
    setOpenFormDialog(true);
  };

  const handleDeleteConfirmation = (auction) => {
    setDeleteAuction(auction);
    setDeleteDialogOpen(true);
  };

  const handleDelete = () => {
    api.delete(`/home-notification/auction/${deleteAuction.id}/`)
      .then(() => {
        setSnackbarMessage('Auction deleted successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        fetchAuctions();
      })
      .catch((error) => {
        console.error('Delete failed:', error);
        setSnackbarMessage('Failed to delete auction.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setDeleteDialogOpen(false);
        setDeleteAuction(null);
      });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.subject?.trim()) errors.subject = 'Subject is required';
    if (!formData.date_of_issue) errors.date_of_issue = 'Date is required';
    if (!formData.language?.trim()) errors.language = 'Language is required';
    if (!selectedFile && !isEditMode) errors.file = 'File is required';
    if (selectedFile && selectedFile.size > 2 * 1024 * 1024) errors.file = 'File size must be less than 2MB';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 2 * 1024 * 1024) {
      setFormErrors((prev) => ({ ...prev, file: 'File size must be less than 2MB' }));
      setSelectedFile(null);
    } else {
      setFormErrors((prev) => ({ ...prev, file: null }));
      setSelectedFile(file);
    }
  };

  const handleFormSubmit = () => {
    if (!validateForm()) return;

    setSubmitLoading(true);

    const form = new FormData();
    form.append('subject', formData.subject);
    form.append('date_of_issue', formData.date_of_issue);
    form.append('language', formData.language);
    if (selectedFile) {
      form.append('link', selectedFile); // backend expects 'link' for the uploaded file
    }

    if (isEditMode) {
      api.patch(
        `/home-notification/auction/${selectedAuction.id}/`,
        form,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      )
        .then(() => {
          setSnackbarMessage('Auction updated successfully.');
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          fetchAuctions();
        })
        .catch((error) => {
          console.error('Update failed:', error);
          setSnackbarMessage('Failed to update auction.');
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        })
        .finally(() => {
          setSubmitLoading(false);
          setOpenFormDialog(false);
        });
    } else {
      api.post(
        `/home-notification/auction/`,
        form,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      )
        .then(() => {
          setSnackbarMessage('Auction added successfully.');
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          fetchAuctions();
        })
        .catch((error) => {
          console.error('Add failed:', error);
          setSnackbarMessage('Failed to add auction.');
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        })
        .finally(() => {
          setSubmitLoading(false);
          setOpenFormDialog(false);
        });
    }
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box
      sx={{
        width: '100%',
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" backgroundColor="rgba(195, 234, 203, 0.1)" p={2}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
          Admin Auction
        </Typography>
        <Button variant="contained" color="primary" onClick={handleAddAuction}>
          Add Auction
        </Button>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort={true}
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }}
      />

      <Dialog open={openFormDialog} onClose={() => setOpenFormDialog(false)}>
        <DialogTitle>{isEditMode ? 'Edit Auction' : 'Add Auction'}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Subject"
            fullWidth
            value={formData.subject}
            error={!!formErrors.subject}
            helperText={formErrors.subject}
            onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Date of Issue"
            type="date"
            fullWidth
            value={formData.date_of_issue}
            error={!!formErrors.date_of_issue}
            helperText={formErrors.date_of_issue}
            onChange={(e) => setFormData({ ...formData, date_of_issue: e.target.value })}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            margin="dense"
            label="Language"
            fullWidth
            value={formData.language}
            error={!!formErrors.language}
            helperText={formErrors.language}
            onChange={(e) => setFormData({ ...formData, language: e.target.value })}
          />
          {/* File Upload Input */}
          <Box mt={2}>
            <input
              accept="*"
              style={{ display: 'block', marginTop: '8px' }}
              id="file-upload"
              type="file"
              onChange={handleFileChange}
            />
            {formErrors.file && (
              <Typography variant="body2" color="error">
                {formErrors.file}
              </Typography>
            )}
            {/* Show existing file download link if in edit mode and no new file chosen */}
            {isEditMode && !selectedFile && selectedAuction?.links && (
              <Typography variant="body2" sx={{ mt: 1 }}>
                Current File:{' '}
                <a href={`${API_BASE_URL}${selectedAuction.links}`} target="_blank" rel="noopener noreferrer">
                  Download
                </a>
              </Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenFormDialog(false)} disabled={submitLoading}>Cancel</Button>
          <Button onClick={handleFormSubmit} variant="contained" color="primary" disabled={submitLoading}>
            {submitLoading ? <LoadingSpinner size={20} /> : (isEditMode ? 'Update' : 'Add')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>Are you sure you want to delete this auction?</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} disabled={submitLoading}>Cancel</Button>
          <Button onClick={handleDelete} variant="contained" color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
    </Box>
  );
};
